(function(){

  'use strict';

  angular.module('eclipseApp.core').factory('changeTechInstallService', ['$window', '$rootScope','$http', 'uteEndpoint', '$log','util', function ($window,$rootScope, $http, uteEndpoint, $log,util) {

    var changeTechInstallService = {
      currentTechInstallAppointment : null,
      newTechInstallAppointment: null,
      newTechInstallChangeSuccessful: false,
      setOrderInfo: function(val) {
        $window.sessionStorage.OrderInfo = JSON.stringify(val);
      },
      getOrderInfo: function(){
        var val = $window.sessionStorage.OrderInfo;

        if(val)
          return JSON.parse(val);

        return false;
      },
      getViewInstallationAppointment: function(){

        var param={};

        param.accountNumber=util.getCacheVariable('internetSelectedAccountNumber');

        return $http({
          url: uteEndpoint('v1/viewInstallationAppointment'),
          method: 'POST',
          cache: false,
          data: param
        }).error(function(resp){
          /*
           * @callback error
           * @description handle http request failure
           */
        });

      },

      /*
       * @description handle EC-6008 276
       * @return Boolean
       * @param orderDetail:Object /getOrderDetail response.data
       */
      parseOrderDetailForEligibleFulfillmentOption: function(orderDetail){
        var respKey = 'productInfo';
        var _services = [],
            _isProvideTp,
            _isCeasedTn;
        if (!orderDetail) return false;
        if (orderDetail &&
            orderDetail[respKey] &&
            orderDetail[respKey].services) {

          if (angular.isArray(orderDetail[respKey].services) &&
              orderDetail[respKey].services.length) {

            _services = angular.copy(orderDetail[respKey].services);
            _services = _.map(_services, function(v){
                          v.actionType = v.actionType.toLowerCase();
                          v.fulfillmentOption = v.fulfillmentOption.toLowerCase();
                          return v;
                        });

            _isProvideTp = _.chain(_services)
                            .find({'actionType': 'provide', 'fulfillmentOption': 'tp'})
                            .isObject()
                            .value();
            /*
            _isCeasedTn = _.chain(_services)
                            .find({'actionType': 'cease', 'fulfillmentOption': 'tn'})
                            .isObject()
                            .value();
                            */

            return (_isProvideTp);

          } else {
            $log.warn('Invalid type, not an Array from /getOrderDetail response');
            return false;
          }


        } else {
          $log.warn('Invalid key for response from /getOrderDetail (key, param)', respKey, orderDetail);
          return false;
        }

      }
    };

    return changeTechInstallService;
  }]);
})();

